import { useEffect, useRef } from "react";

import { useStore } from "../lib/store";
import { cx } from "./ui";

function lineTone(line: string): string {
  const raw = line.toUpperCase();
  if (raw.includes("FAIL") || raw.includes("ERROR")) return "text-fail/80";
  if (raw.includes("OK") || raw.includes("REGED")) return "text-ok/80";
  return "text-mute";
}

/**
 * Right debug drawer. Structured engine lines, never secrets.
 */
export function DebugLog() {
  const lines = useStore().state.debugLog;
  const scroller = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const node = scroller.current;
    if (node) node.scrollTop = node.scrollHeight;
  }, [lines]);
  return (
    <section className="flex min-h-0 flex-1 flex-col border-t border-teal/10">
      <header className="border-b border-teal/10 px-4 py-2 font-mono text-[11px] tracking-[0.18em] text-teal">
        debug.log
      </header>
      <div
        ref={scroller}
        className="scroll-thin min-h-0 flex-1 overflow-auto px-4 py-3 font-mono text-[11px] leading-5"
      >
        {lines.length === 0 ? (
          <div className="text-mute/50">DEBUG</div>
        ) : (
          lines.map((line) => (
            <div key={line.id} className={cx("whitespace-pre-wrap break-all", lineTone(line.line))}>
              <span className="mr-3 text-teal/40">{line.ts.slice(11, 19)}</span>
              {line.line}
            </div>
          ))
        )}
      </div>
    </section>
  );
}
